import { isRtlLang } from '@/plugins/i18n'
import {
  createSwal as createSwalUtil,
  timeoutSwal as timeoutSwalUtil,
} from '@/utils/swal'
export function useSwal() {
  const { t, locale } = useI18n()

  type CreateSwalParams = {
    icon?: string
    title?: string
    confirmColor?: string
    cancelColor?: string
    text?: string
    closeable?: boolean
    confirmButtonText?: string
    cancelButtonText?: string
    direction?: string
  }
  const createSwal = async ({
    icon = '',
    title = '',
    confirmColor,
    cancelColor,
    text = '',
    closeable = true,
    confirmButtonText = 'OK',
    cancelButtonText = 'Cancel',
    direction = isRtlLang(locale.value) ? 'rtl' : 'ltr',
  }: CreateSwalParams) =>
    createSwalUtil({
      icon,
      title,
      confirmColor,
      cancelColor,
      text,
      closeable,
      confirmButtonText: t(confirmButtonText),
      cancelButtonText: t(cancelButtonText),
      direction,
    })

  type TimeoutSwalParams = {
    icon?: string
    title?: string
    text?: string
    lang?: string
    timer?: number
  }
  const timeoutSwal = ({
    icon = 'success',
    title = '',
    text = '',
    lang = locale.value,
    timer = 1500,
  }: TimeoutSwalParams) =>
    timeoutSwalUtil({
      icon,
      title,
      text,
      lang,
      timer,
    })

  // const createInputSwaldata = ({
  //   title,
  //   // inputType = "text",
  //   color = '#2196F3',
  //   presistant = false,
  //   timer = null,
  //   lang = 'he',
  //   confirmButtonText = t('generics.ok'),
  //   cancelButtonText = t('generics.cancel'),
  //   errorMessage = t('errors.notEmpty'),
  // }) => {
  //   let direction = lang === 'he' ? 'rtl' : 'ltr'
  //   let data = {
  //     title,
  //     // input: inputType,
  //     showCancelButton: true,
  //     confirmButtonColor: color,
  //     inputValidator: value => {
  //       if (!value) return errorMessage
  //     },
  //     showConfirmButton: true,
  //     confirmButtonText,
  //     cancelButtonText,
  //     allowOutsideClick: presistant,
  //     reverseButtons: true,
  //     html: `<input style="direction: ${direction} !important;" id="swal-input" class="swal2-input">
  //     <div style='display: flex;flex-direction: column; margin-top: 16px'>
  //     <div><label for="option1">משחק לניידים/מחשבים</label>
  //     <input type="radio" id="option1" name="options" value="firebase" checked></div>
  //     <div><label for="option2">משחק שלטים</label>
  //     <input type="radio" id="option2" name="options" value="remotes"></div>
  //     </div>`,
  //     focusConfirm: false,
  //     preConfirm: () => {
  //       const selectedRadioOption = document.querySelector(
  //         'input[name="options"]:checked'
  //       ).value
  //       const name = document.getElementById('swal-input').value
  //       return { name, setting: { gameType: selectedRadioOption } }
  //     },
  //   }
  //   if (timer) {
  //     data['timer'] = timer
  //     data['timerProgressBar'] = true
  //   }
  //   return Swal.fire({ ...data })
  // }
  return { createSwal, timeoutSwal }
}

export default useSwal
